// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"81e20f5c","732":"ed52a85f","977":"51d498e2"}[chunkId] + ".chunk.js";
};